import { Component } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { PageParams } from 'src/app/core/models/page-params.model';
import { SaleOrderService } from 'src/app/modules/sales-order-management/services/sale-order.service';
@Component({
  selector: 'eci-checkpoints-list-popup',
  templateUrl: './checkpoints-list-popup.component.html',
  styleUrls: ['./checkpoints-list-popup.component.scss']
})
export class CheckpointsListPopupComponent {

  pageParams: PageParams = new PageParams();
  dataSource: MatTableDataSource<any>;
  trackingId: any;

  pageChanged(e: PageParams): void {
    this.pageParams.pageIndex = e.pageIndex;
    this.pageParams.pageSize = e.pageSize;
    // this.getList(e.pageIndex + 1, e.pageSize);
  }
  
  constructor(
    private saleOrderSvc: SaleOrderService,
  ) { }

  displayedColumns: string[] = [
    'checkpointDate',
    'location',
    'subStatus', // TODO MAYBE NEED TO CHANGE TO ENUM
    'message',
  ];

  exportSalesToExcel() {
    if (this.trackingId) {
      this.saleOrderSvc.downloadCheckPoints(this.trackingId).subscribe(() => {});
    }
  }
}
